import { fetchAvailablePromotions } from '@/features/shop/services/Campaigns/fetchers'
import {
  type StoreParamsAsKey,
  useStoreParams,
} from '@/features/shared/utils/dataFetching/storeParams'
import { useQuery } from '@tanstack/react-query'
import { useCurrentActiveOrderId } from '@/features/shop/state/SelectedActiveOrder/hooks'

const PromoQuery = 'Promotions'

const getPromotionsQueryKey = ({
  storeParams,
  currentOrderId,
}: StoreParamsAsKey & { currentOrderId: number | null }) => {
  return [
    PromoQuery,
    {
      storeParams,
      ...(currentOrderId && { currentOrderId }),
    },
  ] as const
}

export type AvailablePromoQueryKey = ReturnType<typeof getPromotionsQueryKey>

const usePromotionsQueryKey = () => {
  const storeParams = useStoreParams()
  const currentOrderId = useCurrentActiveOrderId()
  return getPromotionsQueryKey({
    storeParams,
    currentOrderId,
  })
}

export const useQueryAvailablePromos = () => {
  const queryKey = usePromotionsQueryKey()
  const { store_location_id: storeLocationId } = useStoreParams()

  return useQuery({
    queryKey,
    queryFn: fetchAvailablePromotions,
    enabled: Boolean(storeLocationId),
  })
}
